import { IAuth, } from '@Store';
import { FormElementTypes, FormLayoutTypes, IForm, } from 'atlas-form';
import {
  IPhonenumberSetupCostFormOptionsProps,
  PhonenumberSetupCostAdditionalParams as PhonenumberSetupCostAdditionalParamsBase,
} from './abstract/phonenumber_setup_cost.form.abstract';
import { CountryFlagTitle, } from '@Utils/phone';

export * from './abstract/phonenumber_setup_cost.form.abstract';

export const PhonenumberSetupCostAdditionalParams: (auth: IAuth, props: IPhonenumberSetupCostFormOptionsProps) => IForm['additionalParams'] = (auth: IAuth, props: IPhonenumberSetupCostFormOptionsProps) => ({
  ...PhonenumberSetupCostAdditionalParamsBase(auth, props),
  phonenumber_setup_cost_list: {
    ui_type: FormElementTypes.SECTION,
    child_params: {
      ui_type: FormElementTypes.SECTION,
      ui_layout: FormLayoutTypes.INLINE,
      labelRenderer: label => <CountryFlagTitle t={props.t} country={label as string} width={21} />,
    },
  },
});
